"use strict";

document.querySelectorAll('.js-menu-parent .js-menu-button').forEach(function (button) {
  button.addEventListener('click', function () {
    var parent = button.closest('.js-menu-parent');
    if (parent) {
      var menu = parent.querySelector('.js-menu');
      document.querySelector('body').classList.toggle('menu-open');
      button.classList.toggle('active');
      if (menu) {
        menu.classList.toggle('active');
      }
    }
  });
});